const required = () => (val) => val && (val.length || val === +val);

const minLength = (min) => (val) => val.length >= min;

const maxLength = (max) => (val) => val.length <= max;

const exactLength = (length, callback, field) => (val) => val && val.length === length;

const lengthBetween = (min, max) => (val) => val.length >= min && val.length <= max;

const matches = (exp) => (val) => exp.test(val);

const minValue = (min) => (val) => val >= min; 

const valueIsInteger = () => (val) => (val.length > 0 ? val.match(/^[]?\d+$/) : true);

export const validators = {
  required: (callback, field) => validatorFactory(callback, field, required),
  minLength: (length, callback, field) => validatorFactory(callback, field, minLength, length),
  maxLength: (length, callback, field) => validatorFactory(callback, field, maxLength, length),
  exactLength: (length, callback, field) => validatorFactory(callback, field, exactLength, length),
  lengthBetween: (min, max, callback, field) => validatorFactory(callback, field, lengthBetween, min, max),
  matches: (exp, callback, field) => validatorFactory(callback, field, matches, exp),
  minValue: (min, callback, field) => validatorFactory(callback, field, minValue, min),
  valueIsInteger: (callback, field) => validatorFactory(callback, field, valueIsInteger)
};

const validatorFactory = (callback, field, validator, ...parameters) => {
  return (value) => {
    const valid = validator(...parameters)(value);
    if(callback) callback(field, valid ? null : 'error');
    return valid;
  }
};



// WEBPACK FOOTER //
// ./src/utils/validators.js